(function () {
    //COMPARATIVES
    var initCompsList = function (callback) {
        $('.table_wrap').removeClass('hide');
        $('#advance-listings-map').addClass('hide');
        var formValues = ''; 
        if($('#check_advance_filter').val() !== '0'){
            formValues = $("#form_modal").serializeArray();  
        }
        $('#comps-table').DataTable({
            "pagination": true, //Allows pagination
            "pageLength": 10, //Each page will show 10 entries
            "lengthChange": false, //Does not allow user to change the amount of entries being seen in a page
            "processing": true, //Allows processing animation
            "serverSide": true,//Allows server side processing to happen
            "order": [[1, 'asc'], [2, 'desc']], //First column is last_updated, but it is hidden.
            "columns": [ //Defines the columns based on the sent data from the controller
                {
                    "data": "last_updated",
                    'visible': false
                },
                {"data": "street_address",
                render: function (data, type, full, meta) {
                    return "<a href='#" + full.DT_RowId + "' onclick='CompsController.showDetails(this)' data-id='" + full.DT_RowId + "' title='" + full.street_address + "'>" + full.street_address + "</a>";
                }
                },
                {"data": "sale_price"},
                {"data": "building_size"},
                {"data": "land_size"},
                {"data": "price_square_foot"},
                {"data": "zone"},
                {"data": "date_sold"},
                {
                    "data": "button",
                    render: function (data, type, full, meta) {

                        // buttons = "<a onclick='CompsController.openForm(" + full.DT_RowId + ")' data-activates='slide-out' class='button-collapse tooltipped' data-position='bottom' data-delay='50' data-tooltip='Edit Comp'>" +
                        //     "<i class='edit material-icons'>remove_red_eye</i></a>";
                        buttons = "<a href='" + $("body").data("base-url")+"comps/overview/" + full.DT_RowId + "' class='tooltipped' data-position='bottom' data-delay='50' data-tooltip='Edit Comp'>" +
                            "<i class='edit material-icons'>remove_red_eye</i></a>";

                        buttons = buttons + "<a href='" + $("body").data("base-url") + "master-properties/" + full.masterId + "' title='' class='tooltipped' data-position='bottom' data-delay='50' data-tooltip='View Master Property'>" +
                            "<i class='master material-icons'>equalizer</i></a>";
                        
                        buttons = buttons + "<a data-id='" + full.DT_RowId + "' class='delete delete-comp tooltipped' data-position='bottom' data-delay='50' data-tooltip='Delete Comp' style='cursor: pointer'>" +
                            "<i class='delete properties material-icons'>delete</i></a>";

                        return buttons;
                    }
                }
            ],
            "ajax": {
                'type': 'GET',
                'url': $("body").data("base-url") + "comps/table_get",
                
                'data': function(d) {
                    $.each(formValues, function(key, val) {
                        d[val.name] = val.value;
                    });
                }
            },
            // "ajax": $("body").data("base-url") + "comps/table_get", //Call to the controller every time the table has to be draw
            "drawCallback": function () {
                if (callback !== undefined) {
                    callback();
                }

                $('.tooltipped').tooltip({delay: 50});
            }
        });
    };

    var refreshCompsList = function () {
        $('.table_wrap').removeClass('hide');
        $('#advance-listings-map').addClass('hide');
        $('#comps-table').DataTable().draw();
    };
    var initLeaseList = function (callback) {
        $('.table_wrap').removeClass('hide');
        $('#advance-listings-map').addClass('hide');
        var formValues = ''; 
        if($('#check_advance_filter').val() !== '0'){
            formValues = $("#form_modal").serializeArray();  
        }
        $('#lease-table').DataTable({
            "pagination": true, //Allows pagination
            "pageLength": 10, //Each page will show 10 entries
            "lengthChange": false, //Does not allow user to change the amount of entries being seen in a page
            "processing": true, //Allows processing animation
            "serverSide": true,//Allows server side processing to happen
            "order": [[1, 'asc'], [2, 'desc']], //First column is last_updated, but it is hidden.
            "columns": [ //Defines the columns based on the sent data from the controller
                {
                    "data": "last_updated",
                    'visible': false
                },
                {"data": "street_address",
                render: function (data, type, full, meta) {
                    return "<a href='#" + full.DT_RowId + "' onclick='CompsController.showDetails(this)' data-id='" + full.DT_RowId + "' title='" + full.street_address + "'>" + full.street_address + "</a>";
                }
                },
                {"data": "street_suite"},
                {"data": "price_square_foot"},
                {"data": "lease_type"},
                {"data": "term"},
                {"data": "building_size"},
                {"data": "zone"},
                {
                    "data": "button",
                    render: function (data, type, full, meta) {

                        // buttons = "<a onclick='CompsController.openForm(" + full.DT_RowId + ")' data-activates='slide-out' class='button-collapse tooltipped' data-position='bottom' data-delay='50' data-tooltip='Edit Comp'>" +
                        //     "<i class='edit material-icons'>remove_red_eye</i></a>";
                        buttons = "<a href='" + $("body").data("base-url")+"comps/overview/" + full.DT_RowId + "' class='tooltipped' data-position='bottom' data-delay='50' data-tooltip='Edit Comp'>" +
                        "<i class='edit material-icons'>remove_red_eye</i></a>";

                        buttons = buttons + "<a href='" + $("body").data("base-url") + "master-properties/" + full.masterId + "' title='' class='tooltipped' data-position='bottom' data-delay='50' data-tooltip='View Master Property'>" +
                            "<i class='master material-icons'>equalizer</i></a>";

                        buttons = buttons + "<a data-id='" + full.DT_RowId + "' class='delete delete-comp tooltipped' data-position='bottom' data-delay='50' data-tooltip='Delete Comp' style='cursor: pointer'>" +
                            "<i class='delete properties material-icons'>delete</i></a>";
                        return buttons;
                    }
                }
            ],
            "ajax": {
                'type': 'GET',
                'url': $("body").data("base-url") + "comps/lease_table_get",
                
                'data': function(d) {
                    $.each(formValues, function(key, val) {
                        d[val.name] = val.value;
                    });
                }
            },
            // "ajax": $("body").data("base-url") + "comps/lease_table_get", //Call to the controller every time the table has to be draw
            "drawCallback": function () {
                if (callback !== undefined) {
                    callback();
                }

                $('.tooltipped').tooltip({delay: 50});
            }
        });
    };

    var refreshLeaseList = function () {
        $('.table_wrap').removeClass('hide');
        $('#advance-listings-map').addClass('hide');
        $('#lease-table').DataTable().draw();
    };

    var initAccountsList = function () {
        $('#accounts-table').DataTable({
            "pagination": true, //Allows pagination
            "pageLength": 10, //Each page will show 10 entries
            "lengthChange": false, //Does not allow user to change the amount of entries being seen in a page
            "processing": true, //Allows processing animation
            "serverSide": true,//Allows server side processing to happen
            "order": [[1, 'asc'], [3, 'desc']], //First column is last_updated, but it is hidden.
            "columns": [ //Defines the columns based on the sent data from the controller
                {
                    "data": "last_updated",
                    'visible': false
                },
                {"data": "name"},
                {"data": "forms"},
                {"data": "users"},
                {"data": "comps"},
                {"data": "subscription"},
                {"data": "buttons"},
                {"data": "eval_access",
                'visible': false}
            ],
            "columnDefs": [
                {
                    "targets": 'no-sort',
                    "orderable": false,
                    "bSort": false,
                    "order": []
                },
                {
                    "aTargets": [2, 3, 4],
                    "bSortable": true,
                    "sType": 'numeric'
                }
            ],
            "ajax": $("body").data("base-url") + "accounts/table_get",
            "drawCallback": function () {
                $('.tooltipped').tooltip({delay: 50});
                $('#accounts-table_filter').hide();
                initInviteOptin();
            }
        });

        $('#accounts-table_filter').hide();
    };

    var initInviteOptin = function () {
        $('.invite-brokers').click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            var name = $(this).attr('data-account');
            var id = $(this).attr('data-account-id');

            $('#account-name').html(name);
            $('#account-name').removeClass('hide');

            $('#account-id').val(id);

            $('#invite-people').modal('open');
        });
    };

    var refreshAccountsList = function () {
        $('#accounts-table').DataTable().draw();
    };

    var initUsersList = function () {
        $('#users-table').DataTable({
            "pagination": true, //Allows pagination
            "pageLength": 10, //Each page will show 10 entries
            "lengthChange": false, //Does not allow user to change the amount of entries being seen in a page
            "processing": true, //Allows processing animation
            "serverSide": true,//Allows server side processing to happen
            "order": [[1, 'asc'], [2, 'asc']], //First column is last_updated, but it is hidden.
            "columns": [ //Defines the columns based on the sent data from the controller
                {
                    "data": "last_updated",
                    'visible': false,
                    "searchable": false
                },
                {"data": "name"},
                {"data": "email"},
                {"data": "role"},
                {"data": "status"},
                {"data": "account"},
                {
                    "data": "buttons",
                    "searchable": false
                }
            ],
            "columnDefs": [
                {
                    "targets": 'no-sort',
                    "orderable": false,
                    "bSort": false,
                    "order": []
                },
                {"aTargets": [1, 2, 3, 4, 5, 6], "bSortable": true}
            ],
            "ajax": $("body").data("base-url") + "users/table_get",
            "drawCallback": function () {
                $('.tooltipped').tooltip({delay: 50});
                $('#users-table_filter').hide();
            }
        });

        $('#users-table_filter').hide();
    };

    var initPagesList = function () {
        $('#pages-table').DataTable({
            "pagination": true, //Allows pagination
            "pageLength": 10, //Each page will show 10 entries
            "lengthChange": false, //Does not allow user to change the amount of entries being seen in a page
            "processing": true, //Allows processing animation
            "serverSide": true,//Allows server side processing to happen
            "order": [[0, 'desc']], //First column is last_updated, but it is hidden.
            "columns": [ //Defines the columns based on the sent data from the controller
                {
                    "data": "last_updated",
                    'visible': false
                },
                {"data": "title"},
                {"data": "slug"},
                {"data": "icon"},
                {"data": "author"},
                {"data": "created"},
                {
                    "data": "options",
                    render: function (data, type, full, meta) {
                        return "<a href='" + $("body").data("base-url") + 'pages/edit/' + full.DT_RowId + "' class='tooltipped' data-position='bottom' data-delay='50' data-tooltip='Edit'> " +
                            "<i class='material-icons'>remove_red_eye</i>" +
                            "</a>&nbsp;&nbsp;" +
                            "<form action='" + $("body").data("base-url") + "pages/delete' style='display:inline-block;padding:0;' method='post'>" +
                            "<input type='hidden' name='id' value='" + full.DT_RowId + "'><button type='submit' class='delete tooltipped' style='border: 0; background: 0; color: indianred;' data-position='bottom' data-delay='50' data-tooltip='Delete'>" +
                            "<img class='delete properties' src='" + $('body').data('base-url') + "assets/img/delete.png'>" +
                            "</button>" +
                            "</form>";
                    }
                }
            ],
            "columnDefs": [{
                "targets": 'no-sort',
                "orderable": false,
                "bSort": false,
                "order": []
            }],
            "ajax": $("body").data("base-url") + "cms/pages_get",
            "drawCallback": function () {
                $('.tooltipped').tooltip({delay: 50});
                $('#pages-table_filter').hide();
            }
        });

        $('#pages-table_filter').hide();
    };

    var initMenusList = function () {
        $('#menus-table').DataTable({
            "pagination": true, //Allows pagination
            "pageLength": 10, //Each page will show 10 entries
            "lengthChange": false, //Does not allow user to change the amount of entries being seen in a page
            "processing": true, //Allows processing animation
            "serverSide": true,//Allows server side processing to happen
            "order": [[0, 'desc']], //First column is last_updated, but it is hidden.
            "columns": [ //Defines the columns based on the sent data from the controller
                {"data": "name"},
                {
                    "data": "options",
                    render: function (data, type, full, meta) {
                        return "<a href='" + $("body").data("base-url") + 'menus/edit/' + full.DT_RowId + "' class='tooltipped' data-position='bottom' data-delay='50' data-tooltip='Edit'> " +
                            "<i class='material-icons'>remove_red_eye</i>" +
                            "</a>&nbsp;&nbsp;";
                    }
                }
            ],
            "columnDefs": [{
                "targets": 'no-sort',
                "orderable": false,
                "bSort": false,
                "order": []
            }],
            "ajax": $("body").data("base-url") + "cms/menus_get",
            "drawCallback": function () {
                $('.tooltipped').tooltip({delay: 50});
                $('#menus-table_filter').hide();
            }
        });

        $('#menus-table_filter').hide();
    };

    var refreshUsersList = function () {
        $('#users-table').DataTable().draw();
    };

    var initClientsList = function () {
        $('#clients-table').DataTable({
            "pagination": true, //Allows pagination
            "pageLength": 10, //Each page will show 10 entries
            "lengthChange": false, //Does not allow user to change the amount of entries being seen in a page
            "processing": true, //Allows processing animation
            "serverSide": true,//Allows server side processing to happen
            "order": [[0, 'asc']], //First column is last_updated, but it is hidden.
            "columns": [ //Defines the columns based on the sent data from the controller
                // {
                //     "data": "last_updated",
                //     'visible': false
                // },
                {
                    "data": "name"
                },
                {
                    "data": "company"
                },
                {
                    "data": "buttons"
                }
            ],
            "columnDefs": [{
                "targets": 'no-sort',
                "orderable": false,
                "bSort": false,
                "order": []
            }],
            "ajax": $("body").data("base-url") + "clients/table_get",
            "drawCallback": function () {
                $('.tooltipped').tooltip({delay: 50});
                $('#clients-table_filter').hide();
            }
        });

        $('#clients-table_filter').hide();
    };

    var refreshClientsList = function () {
        $('#clients-table').DataTable().draw();
    };
    //END-COMPARATIVES

    //PROPERTIES
    var initPropertiesList = function (callback) {
        $('#properties-table').DataTable({
            "pagination": true, //Allows pagination
            "pageLength": 10, //Each page will show 10 entries
            "lengthChange": false, //Does not allow user to change the amount of entries being seen in a page
            "processing": true, //Allows processing animation
            "language": {
                processing: ' <div class="progress">' +
                '      <div class="indeterminate"></div>' +
                '  </div> '
            },
            "serverSide": true,//Allows server side processing to happen
            "order": [[0, 'desc']], //First column is last_updated, but it is hidden.
            "columns": [ //Defines the columns based on the sent data from the controller
                {
                    "data": "last_updated",
                    'visible': false
                },
                {
                    "data": "business_name",
                    render: function (data, type, full, meta) {
                        return "<a href='#" + full.DT_RowId + "' onclick='PropertiesController.showDetails(this)' data-id='" + full.DT_RowId + "' title='" + full.business_name + "'>" + full.business_name + "</a>";
                    }
                },
                {"data": "street_address"},
                {"data": "zone", "orderable": false},
                {"data": "asking_price"},
                {"data": "created"},
                {"data": "expiration_date"},
                {
                    "data": "options",
                    render: function (data, type, full, meta) {
                        var buttons = '';
                        var url = $("body").data("base-url");
                        // if (full.canEdit) {
                            buttons = "<a href='" + url + 'properties/overview/' + full.DT_RowId + "' class='tooltipped' data-position='bottom' data-delay='50' data-tooltip='Edit Listing'> " +
                                "<i class='edit material-icons'>remove_red_eye</i></a>";

                            // if (full.canAdmin) {
                                buttons = buttons + "<a href='" + url + "master-properties/" + full.masterId + "' title='' class='tooltipped' data-position='bottom' data-delay='50' data-tooltip='View Master Property'>" +
                                    "<i class='master material-icons'>equalizer</i></a>";
                            // }

                            buttons = buttons + "<form action='" + url + "properties/delete' method='post'>" +
                                "<input type='hidden' name='id' value='" + full.DT_RowId + "'>" +
                                "<button type='submit' class='delete tooltipped' data-position='bottom' data-delay='50' data-tooltip='Delete Property'>" +
                                "<i class='delete properties material-icons'>delete</i></form>";
                        // }else{
                        //     buttons = buttons + "<a href='" + url + "master-properties/" + full.masterId + "' title='' class='tooltipped' data-position='bottom' data-delay='50' data-tooltip='View Master Property'>" +
                        //     "<i class='master material-icons'>equalizer</i></a>";
                        // }

                        return buttons;
                    }
                }
            ],
            "rowCallback": function (row, data) {
                if (!data.available) {
                    $(row).addClass('closed');
                }
            },
            "ajax": getPropertiesEndpoint(),
            "drawCallback": function () {
                if (callback !== undefined) {
                    callback();
                }

                $('.tooltipped').tooltip({delay: 50});
            }
        });

        // Confirm that deletion should fire
        $('#properties-table').on('click', '.delete', function (e) {

            e.preventDefault();
            var $this = this;

            deleteConfirm(function () {
                $($this).parent('form').trigger('submit');
            });
        });
    };
    var initResCompsList = function (callback) {
        $('.table_wrap').removeClass('hide');
        $('#advance-listings-map').addClass('hide');
        var formValues = ''; 
        if($('#check_advance_filter').val() !== '0'){
            formValues = $("#form_modal").serializeArray();  
        }
        $('#res-comps-table').DataTable({
            "pagination": true, //Allows pagination
            "pageLength": 10, //Each page will show 10 entries
            "lengthChange": false, //Does not allow user to change the amount of entries being seen in a page
            "processing": true, //Allows processing animation
            "serverSide": true,//Allows server side processing to happen
            "order": [[1, 'asc'], [2, 'desc']], //First column is last_updated, but it is hidden.
            "columns": [ //Defines the columns based on the sent data from the controller
                {
                    "data": "last_updated",
                    'visible': false
                },
                {"data": "street_address",
                render: function (data, type, full, meta) {
                    return "<a href='#" + full.DT_RowId + "' onclick='ResCompsController.showDetails(this)' data-id='" + full.DT_RowId + "' title='" + full.street_address + "'>" + full.street_address + "</a>";
                }
                },
                {"data": "sale_price"},
                {"data": "building_size"},
                {"data": "land_size"},
                {"data": "price_square_foot"},
                {"data": "date_sold"},
                {
                    "data": "button",
                    render: function (data, type, full, meta) {

                        // buttons = "<a onclick='ResCompsController.openForm(" + full.DT_RowId + ")' data-activates='slide-out' class='button-collapse tooltipped' data-position='bottom' data-delay='50' data-tooltip='Edit Comp'>" +
                        //     "<i class='edit material-icons'>remove_red_eye</i></a>";
                        buttons = "<a href='" + $("body").data("base-url")+"res_comps/overview/" + full.DT_RowId + "' class='tooltipped' data-position='bottom' data-delay='50' data-tooltip='Edit Comp'>" +
                            "<i class='edit material-icons'>remove_red_eye</i></a>";
                        buttons = buttons + "<a href='" + $("body").data("base-url") + "res-master-properties/" + full.masterId + "' title='' class='tooltipped' data-position='bottom' data-delay='50' data-tooltip='View Master Property'>" +
                            "<i class='master material-icons'>equalizer</i></a>";
                        buttons = buttons + "<a data-id='" + full.DT_RowId + "' class='delete delete-res-comp tooltipped' data-position='bottom' data-delay='50' data-tooltip='Delete Comp' style='cursor: pointer'>" +
                            "<i class='delete properties material-icons'>delete</i></a>";
                        return buttons;
                    }
                }
            ],
            "ajax": {
                'type': 'GET',
                'url': $("body").data("base-url") + "res_comps/table_get",
                'data': function(d) {
                    $.each(formValues, function(key, val) {
                        d[val.name] = val.value;
                    });
                }
            },
            "drawCallback": function () {
                if (callback !== undefined) {
                    callback();
                }
                $('.tooltipped').tooltip({delay: 50});
            }
        });
    };
    var refreshResCompsList = function () {
        $('.table_wrap').removeClass('hide');
        $('#advance-listings-map').addClass('hide');
        $('#res-comps-table').DataTable().draw();
    };

    $(document).on('click','.delete-client', function (e) {
        e.preventDefault();
        var clientid = $(this).data('clientid');
        deleteConfirm(function () {

            request = $.ajax({
                type: 'GET', // your request type
                url: 'clients/delete/'+ clientid,
                data: {},
                success: function (response) {
                    Materialize.toast(response, 3000);
                    location.reload();
                },
                complete: function () {
                    runningRequest = false;
                }
            });
        });
    });

    $(document).on('click','.delete-user', function (e) {
        e.preventDefault();
        var userid = $(this).data('userid');
        deleteConfirm(function () {

            request = $.ajax({
                type: 'GET', // your request type
                url: 'users/delete/'+ userid,
                data: {},
                success: function (response) {
                    Materialize.toast(response, 3000);
                    location.reload();
                },
                complete: function () {
                    runningRequest = false;
                }
            });
        });
    });

    $(document).on('click','.delete-account', function (e) {
        e.preventDefault();
        var userid = $(this).data('accountid');
        deleteConfirm(function () {

            request = $.ajax({
                type: 'GET', // your request type
                url: 'accounts/delete/'+ userid,
                data: {},
                success: function (response) {
                    Materialize.toast(response, 3000);
                    location.reload();
                },
                complete: function () {
                    runningRequest = false;
                }
            });
        });
    });

    $(document).on('click','.delete-bov', function (e) {
        e.preventDefault();
        var $this = this;
        var bovid = $(this).data('bovid');
        deleteConfirm(function () {
            //$($this).parent('form').trigger('submit');

            request = $.ajax({
                type: 'GET', // your request type
                url: 'evaluations/deleteBOV/'+ bovid,
                data: {},
                success: function (response) {
                   location.reload();
                },
                complete: function () {
                    runningRequest = false;
                }
            });
        });
    });

    $(document).on('click','.delete-res_eval', function (e) {
        e.preventDefault();
        var bovid = $(this).data('bovid');
        deleteConfirm(function () {
            request = $.ajax({
                type: 'GET', // your request type
                url: 'res_evaluations/deleteBOV/'+ bovid,
                data: {},
                success: function (response) {
                    var data = JSON.parse(response);
                    Materialize.toast(data.msg,2000);
                    location.reload();
                },
                complete: function () {
                    runningRequest = false;
                }
            });
        });
    });

    $(document).on('click','.delete-coupon', function (e) {
        e.preventDefault();
        var couponid = $(this).data('couponid');
        deleteConfirm(function () {
            request = $.ajax({
                type: 'GET',
                url: 'settings/deleteCoupon/'+ couponid,
                data: {},
                beforeSend: function(){
                $('body').LoadingOverlay("show",
                        {
                            image: $('body').attr('data-base-url') + "assets/img/loading.png",
                            imageAnimation: '2500ms rotate_left',
                            zIndex: 1020,
                            background: "rgba(255, 255, 255, 0.95)"
                        }                  
                    );                 
                },
                success: function (response) {
                    if(response=="1")
                    {
                        Materialize.toast("Successfully Deleted", 2000);
                        window.location.href = '#promo_codes';
                        location.reload();
                    }else{
                        Materialize.toast(response, 2000);
                        $('body').LoadingOverlay("hide");
                    }
                },
                complete: function () {
                    runningRequest = false;
                }
            });
        });
    });

    $(document).on('click','.delete-comp', function (e) {
        e.preventDefault();
        var $this = this;
        var id = $(this).data('id');
        deleteConfirm(function () {
            request = $.ajax({
                type: 'POST', // your request type
                url: $("body").data("base-url") + "comps/delete",
                data: { id : id },
                beforeSend: function(){
                    startLoading('body');               
                },
                success: function (responseText) {
                    var comp = JSON.parse(responseText);
                    if(comp == "existInEval")
                    {
                        Materialize.toast("This comp is currently used in an Evaluation and cannot be deleted.", 2000);
                    }else if (comp.id) {
                        TableController.Comps.refresh();
                        TableController.Lease.refresh();
                        $('.table_wrap').removeClass('hide');
                        Materialize.toast("Comparative has been removed.", 2000);
                    }
                },
                failure: function (errMsg) {
                    Materialize.toast("It was not possible to remove comparative right now.", 2000);
                },
                complete: function () {
                    runningRequest = false;
                }
            }).done(function () {
                stopLoading('body');
            });;
        });
    });

    $(document).on('click','.delete-res-comp', function (e) {
        e.preventDefault();
        var $this = this;
        var id = $(this).data('id');
        deleteConfirm(function () {
            request = $.ajax({
                type: 'POST', // your request type
                url: $("body").data("base-url") + "res_comps/delete",
                data: { id : id },
                beforeSend: function(){
                    startLoading('body');               
                },
                success: function (responseText) {
                    var comp = JSON.parse(responseText);
                    if(comp == "existInEval")
                    {
                        Materialize.toast("This comp is currently used in an Evaluation and cannot be deleted.", 2000);
                    }else if (comp.id) {
                        TableController.ResComps.refresh();
                        $('.table_wrap').removeClass('hide');
                        $('#advance-listings-map').addClass('hide');
                        Materialize.toast("Comparative has been removed.", 2000);
                    }
                },
                failure: function (errMsg) {
                    Materialize.toast("It was not possible to remove comparative right now.", 2000);
                },
                complete: function () {
                    runningRequest = false;
                }
            }).done(function () {
                stopLoading('body');
            });;
        });
    });

    var getPropertiesEndpoint = function () {
        var broker = $.query.get('broker');

        if (broker) {
            return $("body").data("base-url") + "properties/table_get?broker=" + broker;
        } else {
            return $("body").data("base-url") + "properties/table_get";
        }
    };

    var refreshPropertiesList = function () {
        $('#settings-table').DataTable().draw();
    };
    //MASTER PROPERTIES
    var initMasterPropertiesList = function (callback) {
        var masterTable = $('#master-properties-table');

        $('#master-properties-table_filter').remove();
        masterTable.DataTable({
            "pagination": true, //Allows pagination
            "pageLength": 10, //Each page will show 10 entries
            "lengthChange": false, //Does not allow user to change the amount of entries being seen in a page
            "processing": true, //Allows processing animation
            "language": {
                processing: ' <div class="progress">' +
                '      <div class="indeterminate"></div>' +
                '  </div> '
            },
            "serverSide": true,//Allows server side processing to happen
            "order": [[0, 'desc']], //First column is last_updated, but it is hidden.
            "columns": [ //Defines the columns based on the sent data from the controller
                {
                    "data": "last_updated",
                    'visible': false
                },
                {
                    "data": "address",
                    render: function (data, type, full, meta) {
                        return "<a href='" + $("body").data("base-url") + 'master-properties/' + full.DT_RowId + "'>" + full.address + "</a>";
                    }
                },
                {"data": "city"},
                {"data": "county"},
                {"data": "state"},
                {"data": "zipcode"},
                {
                    "data": "options",
                    render: function (data, type, full, meta) {
                        return "<a href='" + $("body").data("base-url") + 'master-properties/' + full.DT_RowId + "' class='tooltipped' data-position='bottom' data-delay='50' data-tooltip='View'> " +
                            "<img class='edit' src='" + $("body").data("base-url") + "/assets/img/visibility-button.png'>" +
                            "</a>&nbsp;&nbsp;";
                    }
                }
            ],
            "rowCallback": function (row, data) {
                if (!data.available) {
                    $(row).addClass('closed');
                }
            },
            "ajax": getMasterPropertiesEndpoint(),
            "drawCallback": function () {
                if (callback !== undefined) {
                    callback();
                }

                $('.tooltipped').tooltip({delay: 50});
                $('#master-properties-table_filter').remove();
            }
        });

        masterTable.find('tfoot th').each(function () {
            var title = $(this).text();
            $(this).html('<input type="text" placeholder="Search ' + title + '" />');
        });

        var table = masterTable.DataTable();

        // Apply the search
        table.columns().every(function () {
            var that = this;

            $('input', this.footer()).on('keyup change', _.debounce(function () {
                if (that.search() !== this.value) {
                    that
                        .search(this.value)
                        .draw();
                }
            }, 500));
        });

        // Confirm that deletion should fire
        masterTable.on('click', '.delete', function (e) {

            e.preventDefault();
            var $this = this;

            deleteConfirm(function () {
                $($this).parent('form').trigger('submit');
            });
        });
    };

    var getMasterPropertiesEndpoint = function () {
        var broker = $.query.get('broker');

        if (broker) {
            return $("body").data("base-url") + "master_properties/get";
        } else {
            return $("body").data("base-url") + "master_properties/get";
        }
    };

    var refreshMasterPropertiesList = function () {
        $('#master-properties-table').DataTable().draw();
    };

    //Settings
    var initSettingsList = function (callback) {
        $('#settings-table').DataTable({
            "pagination": true, //Allows pagination
            "pageLength": 10, //Each page will show 10 entries
            "lengthChange": false, //Does not allow user to change the amount of entries being seen in a page
            "processing": true, //Allows processing animation
            "language": {
                processing: ' <div class="progress">' +
                '      <div class="indeterminate"></div>' +
                '  </div> '
            },
            "serverSide": true,//Allows server side processing to happen
            "order": [[0, 'desc']], //First column is last_updated, but it is hidden.
            "columns": [ //Defines the columns based on the sent data from the controller
                {
                    "data": "id",
                    'visible': false
                },
                {"data": "name"},
                {"data": "value"},
                {
                    "data": "options",
                    render: function (data, type, full, meta) {
                        return "<a href='" + $("body").data("base-url") + 'settings/edit/' + full.DT_RowId + "'>" +
                            "<i class='material-icons'>remove_red_eye</i>" +
                            "</a>&nbsp;&nbsp;" +
                            "<form action='" + $("body").data("base-url") + "settings/delete' style='display:inline-block;padding:0;' method='post'><input type='hidden' name='id' value='" + full.DT_RowId + "'><button type='submit' style='border: 0; background: 0; color: indianred;'><i class='material-icons'>remove_circle</i></button></form>";
                    }
                }
            ],
            "ajax": $("body").data("base-url") + "settings/table_get", //Call to the controller every time the table has to be draw
            "drawCallback": function () {
                if (callback !== undefined) {
                    callback();
                }

                $('.tooltipped').tooltip({delay: 50});
            }
        });
    };

    var refreshSetttingsList = function () {
        $('#settings-table').DataTable().draw();
    };

    //Settings
    var initFilesList = function (callback) {
        var attachments = $('#attachments-table');
        attachments.DataTable({
            "pagination": true, //Allows pagination
            "pageLength": 10, //Each page will show 10 entries
            "lengthChange": false, //Does not allow user to change the amount of entries being seen in a page
            "processing": true, //Allows processing animation
            "language": {
                processing: '<div class="progress">' +
                '<div class="indeterminate"></div>' +
                '</div>'
            },
            "serverSide": true,//Allows server side processing to happen
            "order": [[0, 'desc']], //First column is last_updated, but it is hidden.
            "columns": [ //Defines the columns based on the sent data from the controller
                {"data": "title"},
                {"data": "description"},
                {"data": "filename"},
                {
                    "data": "options",
                    render: function (data, type, full, meta) {
                        return fill(full, $('#file-upload-buttons-template').html());
                    }
                }
            ],
            // "ajax": $("body").data("base-url") + "files/get?id=" + attachments.attr('data-id') + "&entity=" + attachments.attr('data-entity') + "&origins=" + attachments.attr('data-origins'),
            "ajax": $("body").data("base-url") + "listingfile/get?id=" + attachments.attr('data-id') +  "&origins=" + attachments.attr('data-origins'),
            "drawCallback": function () {
                if (callback !== undefined) {
                    callback();
                }
                FilesController.initializeButtons();
                $('.tooltipped').tooltip({delay: 50});
            }
        });
    };

    var refreshFilesList = function () {
        $('#attachments-table').DataTable().draw();
    };

    var fill = function (data, template) {
        Object.keys(data).forEach(function (key) {
            var placeholder = "{{" + key + "}}";
            var value = data[key];
            while (template.indexOf(placeholder) !== -1) {
                template = template.replace(placeholder, value);
            }
        });
        return template;
    };

    var checkEvalAccess = function(accountId) {
        $.ajax({
            type: "POST",
            url: "accounts/checkEvalAccess",
            data: {
                accountId: accountId,
                checked: !$("#eval_access"+ accountId).is(':checked')
            },
            success: function (responseText) {
                saveToast();
            }
        });
    };

    var init = function () {
        if ($('input#table-search').length > 0) {
            $('input#table-search').keyup(_.debounce(function () {
                var term = $(this).val();
                $('#' + $(this).attr('data-table'))
                    .DataTable()
                    .search(term)
                    .draw();
            }, 500));
        }
        if ($('input.table-search_field').length > 0) {
            $('input.table-search_field').keyup(_.debounce(function () {
                var term = $(this).val();
                $('#' + $(this).attr('data-table'))
                    .DataTable()
                    .search(term)
                    .draw();
            }, 500));
        }
        if($('#payments-table').length){
            $('#payments-table').DataTable({
                "searching": true,
                "lengthChange": false,
                "pagination": true,
                "order": [[1, 'desc']],
            });
        }
    };
    //END-PROPERTIES

    if (window.TableController === undefined) {
        window.TableController = {};
    }

    TableController.Comps = {
        init: initCompsList,
        refresh: refreshCompsList
    };

    TableController.Lease = {
        init: initLeaseList,
        refresh: refreshLeaseList
    };

    TableController.ResComps = {
        init: initResCompsList,
        refresh: refreshResCompsList
    };

    TableController.Accounts = {
        init: initAccountsList,
        refresh: refreshAccountsList
    };

    TableController.Users = {
        init: initUsersList,
        refresh: refreshUsersList
    };

    TableController.Properties = {
        init: initPropertiesList,
        refresh: refreshPropertiesList
    };

    TableController.Clients = {
        init: initClientsList,
        refresh: refreshClientsList
    };


    TableController.Pages = {
        init: initPagesList
    };


    TableController.Menus = {
        init: initMenusList
    };

    TableController.Settings = {
        init: initSettingsList,
        refresh: refreshSetttingsList
    };

    TableController.Files = {
        init: initFilesList,
        refresh: refreshFilesList
    };

    TableController.checkEvalAccess = checkEvalAccess;

    TableController.init = init;
    TableController.initMasterPropertiesList = initMasterPropertiesList;
})();